import React from 'react';

const PlainTextChatBubble = ({ text = '', left }) => {
  return <div className={`message-content ${left && `left`}`}>{text}</div>;
};

export default PlainTextChatBubble;
